import { Avatar, Stack, Typography } from "@mui/material";
import { IMG_BASE_URL } from "src/config/constants";


export default function Merchant({ name = '消费券商城', logo }) {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Avatar alt={name} src={`${IMG_BASE_URL}${logo}?w=60`} />
      <Stack>
        <Typography variant="subtitle2" noWrap>
          {name}
        </Typography>
      </Stack>
    </Stack>
  )
}